import { get, put, post, destroy } from './api'


export const getActiveDialogDefinitions = async () => {
    return await get('dialogDefinitions/active/list');
}